import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'

const Animation = styled.div`
  width: 1000px;
  margin: 0 auto;
  height: 50vh;
  overflow: hidden;

  @media (max-width: 1000px) {
    width: 100%;
  }

  @media print {
    display: none;
  }

  > .wrap {
    width: 100%;
    height: 100%;
    padding-top: 15%;
    display: flex;
    flex-direction: column;

    > h2 {
      margin-left: 222px;
      text-transform: uppercase;
      font-size: 40px;
      font-weight: normal;

      @media (max-width: 1000px) {
        margin: 0;
        text-align: center;
      }

      @media (max-width: 600px) {
        font-size: 20px;
      }
    }

    > .body {
      display: flex;
      justify-content: center;
      align-items: center;

      > span {
        width: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 100px;
        font-weight: bold;

        @media (max-width: 600px) {
          width: 50px;
          font-size: 50px;
        }
      }
    }
  }
`

function StartAnimation() {
  return (
    <Animation>
      <div className="wrap">
        <motion.h2
          initial={{ x: 500, opacity: 0 }}
          animate={{ x: 0, opacity: 1, transition: { delay: 0.3 } }}
        >
          Let's Play
        </motion.h2>
        <div className="body">
          <motion.span
            initial={{ scale: 5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1, transition: { delay: 0.6 } }}
          >
            B
          </motion.span>
          <motion.span
            initial={{ scale: 5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1, transition: { delay: 0.9 } }}
          >
            I
          </motion.span>
          <motion.span
            initial={{ scale: 5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1, transition: { delay: 1.2 } }}
          >
            N
          </motion.span>
          <motion.span
            initial={{ scale: 5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1, transition: { delay: 1.5 } }}
          >
            G
          </motion.span>
          <motion.span
            initial={{ scale: 5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1, transition: { delay: 1.8 } }}
          >
            O
          </motion.span>
          <motion.span
            initial={{ scale: 5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1, transition: { delay: 2.1 } }}
          >
            O
          </motion.span>
        </div>
      </div>
    </Animation>
  )
}

export default React.memo(StartAnimation)
